module.exports = __webpack_public_path__ + "img/fig10.6cc9c281.jpg";